var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoggingService as logger } from "@/logging/LoggingService";
import { LrsStatement } from "@/cmi5/statements/LrsStatement";
const SUSPEND_DATA_KEY = "suspendData";
export const SuspendDataStatement = {
    /**
     * Get the learner's suspend data if one exists.
     *
     * @return {Promise<Response>} The learner's suspend data, or an empty string if no suspend data exists.
     */
    get: () => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield LrsStatement.get(SUSPEND_DATA_KEY);
        return data ? Promise.resolve(data) : Promise.resolve("");
    }),
    /**
     * Save the learner's suspend data only if launchMode isn't "Browse".
     *
     * @param {string} suspendData The new suspend data
     * @return {Promise<Response>} The promise returned by the fetch call representing the xAPI request.
     */
    set: (suspendData) => __awaiter(void 0, void 0, void 0, function* () {
        logger.debug("Set suspend data state...");
        return LrsStatement.set(SUSPEND_DATA_KEY, suspendData);
    })
};
